import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { FeedbackModel } from '@shared/models/feedback.model';

@Injectable({
  providedIn: 'root',
})
export class FeedbackService {
  constructor(private http: HttpClient) {}

  public sendFeedback(feedback: FeedbackModel): Observable<any> {
    return this.http.post<FeedbackModel>(`${environment.apiUrl}/feedback`, {
      ...feedback,
    });
  }
}
